import React from "react";
import useBookingApp from "../../hooks/useBookingApp";

const PrescriptionStatusNotification = () => {
    const { consentState } = useBookingApp();
    const { prescriptionStatusMessage } = consentState || {};

    return (
        <div className="prescription-detail-container">
            <div className="prescription-view-container notification-message">
                <div className="content-container">
                    <img
                        src="https://cdn3.iconfinder.com/data/icons/round-default/64/add-1024.png"
                        alt="Notification Icon"
                        className="notification-icon"
                    />
                    <h4 className="notification-text">{prescriptionStatusMessage}</h4>
                </div>
            </div>
        </div>
    );
};

export default PrescriptionStatusNotification;
